var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quotation" },
    [
      _c("div", { staticClass: "header" }, [
        _c("p", { staticClass: "header-title" }, [_vm._v("实时行情")]),
        _vm._v(" "),
        !_vm.isUcenter
          ? _c(
              "a",
              {
                staticClass: "more",
                attrs: { href: _vm.moreUrl, target: "_blank" }
              },
              [
                _c("span", [_vm._v("更多")]),
                _c("img", { attrs: { src: _vm.moreIcon } })
              ]
            )
          : _c("a", { staticClass: "more", on: { click: _vm.moreClick } }, [
              _c("span", [_vm._v("更多")]),
              _c("img", { attrs: { src: _vm.moreIcon } })
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "currency-content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-list" },
          _vm._l(_vm.metals, function(item, index) {
            return _c("div", { staticClass: "list-item" }, [
              _c("li", { staticClass: "category" }, [
                _vm._v(_vm._s(item.name))
              ]),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "price",
                  class:
                    item.buyTrend == 0
                      ? ""
                      : item.buyTrend == 1
                        ? "up"
                        : "down",
                  on: {
                    click: function($event) {
                      _vm.buyCurrency(item, 0)
                    }
                  }
                },
                [_vm._v(_vm._s(item.buyPrice))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    item.soldTrend == 0
                      ? ""
                      : item.soldTrend == 1
                        ? "up"
                        : "down",
                  on: {
                    click: function($event) {
                      _vm.soldCurrency(item, 1)
                    }
                  }
                },
                [_vm._v(_vm._s(item.soldPrice))]
              )
            ])
          })
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-list" },
          _vm._l(_vm.currencies, function(item, index) {
            return _c("div", { staticClass: "list-item" }, [
              _c("li", { staticClass: "category" }, [
                _vm._v(_vm._s(item.name))
              ]),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "price",
                  class:
                    item.buyTrend == 0
                      ? ""
                      : item.buyTrend == 1
                        ? "up"
                        : "down",
                  on: {
                    click: function($event) {
                      _vm.buyCurrency(item, 0)
                    }
                  }
                },
                [_vm._v(_vm._s(item.buyPrice))]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class:
                    item.soldTrend == 0
                      ? ""
                      : item.soldTrend == 1
                        ? "up"
                        : "down",
                  on: {
                    click: function($event) {
                      _vm.soldCurrency(item, 1)
                    }
                  }
                },
                [_vm._v(_vm._s(item.soldPrice))]
              )
            ])
          })
        )
      ]),
      _vm._v(" "),
      _vm.showLoginDialog
        ? _c("pop-login", { on: { popClose: _vm.popClose } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTradeDialog
        ? _c(
            "popup",
            { attrs: { "is-default": _vm.isDefaultDialog } },
            [
              _vm.orderCurrency.name != "" && _vm.accounts.length > 0
                ? _c("trade-dialog", {
                    attrs: {
                      cmd: _vm.cmd,
                      "trade-accounts": _vm.accounts,
                      title: _vm.tradeDialogTitle,
                      "trade-info": _vm.orderCurrency,
                      "is-ucenter": _vm.isUcenter
                    },
                    on: { "close-click": _vm.closeTradeDialog }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-header" }, [
      _c("li", { staticClass: "title" }, [_vm._v("贵金属")]),
      _vm._v(" "),
      _c("li", { staticClass: "price" }, [_vm._v("买入价")]),
      _vm._v(" "),
      _c("li", [_vm._v("卖出价")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-header m-top" }, [
      _c("li", { staticClass: "title" }, [_vm._v("货币类型")]),
      _vm._v(" "),
      _c("li", { staticClass: "price" }, [_vm._v("买入价")]),
      _vm._v(" "),
      _c("li", [_vm._v("卖出价")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fffc652", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fffc652","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/currency/quotation.vue
// module id = 525
// module chunks = 0 1